<template>
    <div :class="['rating-banner', { webmaster: isWebmasterRole }]">
        <div class="rating-banner_wrapper-info">
            <div>
                <h2 class="has-text-white is-size-6 mb-1">
                    {{ $t("common.rating.banner.date") }}
                </h2>
                <h2
                    class="rating-banner_title"
                    style="max-width: 450px">
                    <i18n path="common.rating.banner.title">
                        <template #competitionName>
                            <span class="rating-banner_name">
                                “SPRING RACE”
                            </span>
                        </template>
                    </i18n>
                </h2>
            </div>
            <div
                v-if="isWebmasterRole && hasDashboard"
                class="rating-banner_wrapper-place flex is-flex-wrap-wrap mt-3">
                <div class="rating-banner_place mr-4">
                    <h3 class="has-text-white">
                        {{ $t("common.rating.banner.webmaster.tickets") }}
                    </h3>
                    <div class="is-align-items-center">
                        <p class="has-text-white is-size-3 has-text-weight-bold main-text-color">
                            {{ (currentCompetition && currentCompetition.balance) || 0 }}
                        </p>
                        <img
                            alt="Ticket"
                            class="ml-2"
                            style="width: 28px; height: 28px;"
                            src="@/assets/Competition/Raffle/noto_coin.svg">
                    </div>
                    <b-button
                        size="is-small"
                        type="is-white"
                        class="mt-3 p-4 is-size-6"
                        style="width: 100%"
                        @click.prevent.stop="isActive = true">
                        {{ $t("admin.dashboard.competition.banner.button") }}
                    </b-button>
                </div>
                <div class="rating-banner_place mr-4">
                    <h3 class="has-text-white">
                        {{ $t("common.rating.banner.webmaster.placeRating") }}
                    </h3>
                    <div class="flex">
                        <p class="has-text-white is-size-3 has-text-weight-bold">
                            {{ formatEmptyString(place.place) }}
                        </p>
                    </div>
                    <router-link
                        :to="{
                            name: 'webmaster:competitionRating',
                            query: { backLink: $route.fullPath }
                        }">
                        <b-button
                            style="width: 100%"
                            class="mt-3 p-4 is-size-6">
                            {{ $t("common.rating.banner.webmaster.rating") }}
                        </b-button>
                    </router-link>
                </div>
                <router-link
                    :to="{
                        name: 'webmaster:offers',
                        query: {
                            backLink: $route.fullPath,
                            filters: encodeFilters({ inCompetition: true })
                        }
                    }"
                    class="competition-offers">
                    <b-button
                        style="width: 100%"
                        class="mt-4 p-4 is-size-6">
                        {{ $t("common.rating.banner.webmaster.competitionOffers") }}
                    </b-button>
                </router-link>
            </div>
            <div
                v-else
                class="mt-3 has-text-white">
                {{ $t("common.rating.banner.description") }}
            </div>
        </div>
        <div class="rating-banner_wrapper-prizes">
            <div
                :key="idx"
                v-for="(el, idx) in prizes"
                class="rating-banner_prize-el">
                <div class="rating-banner_prize">
                    <h3 class="rating-banner_prize-title">
                        {{ $t(`common.rating.banner.${ el }.title`) }}
                    </h3>
                    <p class="rating-banner_prize-info mb-2">
                        {{ $t(`common.rating.banner.${ el }.info`) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { formatEmptyString } from "@/filters";
  import { mapGetters, mapState } from "vuex";
  import { encodeFilters } from "@core/filters";
  import { mapFields } from "@vasiliyrusin/vue-mapfields";
  import { UPDATE_OPTIONS } from "@core/store/action-constants";

  export default {
    name: "CompetitionRatingBanner",

    props: {
      place: {
        type: Object,
        default: () => ({})
      }
    },

    computed: {
      ...mapGetters(["role"]),

      ...mapState("competition", {
        currentCompetition: ({ currentCompetition }) => currentCompetition
      }),

      ...mapFields("competition", {
        fields: ["isActive"],
        base: "options",
        action: UPDATE_OPTIONS
      }),

      isWebmasterRole () {
        return this.role === "webmaster";
      },

      hasDashboard () {
        return this.$route.name === "dashboard";
      },

      prizes () {
        return ["firstPlace", "secondPlace", "thirdPlace"];
      }
    },

    methods: {
      encodeFilters,
      formatEmptyString
    }
  };
</script>

<!--suppress SassScssResolvedByNameOnly -->
<style scoped lang="scss">
  @import "~@/scss/competition-banner";

  .columns:not(:last-child) {
    margin-bottom: -0.75rem !important;
  }

  .rating-banner {
    $self: &;

    #{$self}_prize-el {
      position: relative;
      width: 33.333%;
      margin-bottom: 20px;

      &:not(:last-child) {
        margin-right: 20px;
      }

      &:nth-child(1)::before {
        @extend %beforeStyle;
        bottom: -84px;
        left: -126px;
        z-index: 0;

        width: 167px;
        height: 257px;
        background-image: url("~@/assets/Competition/Raffle/leaves.png");
      }

      &:nth-child(1)::after {
        @extend %beforeStyle;
        bottom: -213px;
        left: 20%;
        z-index: 1;

        width: 368px;
        height: 255px;
        background-image: url("~@/assets/Competition/Raffle/macBook.png");
        transform: translate(-50%, 0);
      }

      &:nth-child(2)::after {
        @extend %beforeStyle;
        bottom: -264px;
        left: 50%;
        z-index: 1;

        width: 348px;
        height: 348px;

        transform: rotate(2deg) translate(-50%, 0);
        background-image: url("~@/assets/Competition/Raffle/mac.png");
      }

      &:nth-child(3)::before {
        @extend %beforeStyle;
        bottom: -216px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 3;

        width: 286px;
        height: 254px;
        background-image: url("~@/assets/Competition/Raffle/iphone-orange.png");
      }

      &:nth-child(3)::after {
        @extend %beforeStyle;
        top: -110px;
        right: -133px;
        transform: rotate(330deg);
        z-index: 0;

        width: 225px;
        height: 306px;
        background-image: url("~@/assets/Competition/Raffle/leaves.png");
      }
    }

    .button {
      color: black;
    }

    &.webmaster {
      #{$self}_prize-el {
        height: 60%;
      }

      @media screen and (max-width: 1500px) {
        &::after,
        #{$self}_prize-el:nth-child(1)::before,
        #{$self}_prize-el:nth-child(1)::after,
        #{$self}_prize-el:nth-child(2)::after,
        #{$self}_prize-el:nth-child(3)::before {
          display: none;
        }
      }
    }

    &_wrapper-place {
      align-items: end;

      @media screen and (max-width: 769px) {
        display: flex;
        justify-content: space-between;

        #{$self}_place {
          width: 49%;
          margin-right: 0 !important;
        }

        .competition-offers {
          width: 100%;
        }
      }
    }

    &_wrapper-prizes {
      position: relative;
      display: flex;
      width: 60%;

      #{$self}_prize {
        @extend %verticalCenter;

        position: relative;
        z-index: 1;

        height: 100%;
        padding: 27px 6px;

        box-shadow: 0 0 10px 0 rgba(23, 140, 139, 0.5);
        border-radius: 30px;
        background: #fff;

        &-title {
          margin-bottom: 6px;
          text-align: center;
          font-size: 28px;
          line-height: 33px;
          color: black;
        }

        &-info {
          font-weight: 600;
          color: #1f9b00;
          text-align: center;
          font-size: 38px;
          line-height: 45px;
        }
      }
    }

    @media screen and (max-width: 470px) {
      #{$self}_place {
        width: 100%;

        &:first-child {
          margin-bottom: 10px;
        }
      }
      #{$self}_title {
        font-size: 20px;
        line-height: 32px;
      }
    }
  }
</style>
